export interface CustomerPrice {
  id: string;
  priceListId: string;
  customerId: string;
  customerKey: string;
  customerName: string;
  selected: boolean;
}
